// wp-icons — Actions (CRUD) 11
import { createWpIcon } from './createIcon.js';

export const Plus = createWpIcon('Plus', [
  ['path', { d: 'M5 12h14', key: 'a' }],
  ['path', { d: 'M12 5v14', key: 'b' }],
]);
export const X = createWpIcon('X', [
  ['path', { d: 'M18 6 6 18', key: 'a' }],
  ['path', { d: 'm6 6 12 12', key: 'b' }],
]);
export const Check = createWpIcon('Check', [['path', { d: 'M20 6 9 17l-5-5', key: 'a' }]]);
export const CheckCheck = createWpIcon('CheckCheck', [
  ['path', { d: 'M18 6 7 17l-5-5', key: 'a' }],
  ['path', { d: 'm22 10-7.5 7.5L13 16', key: 'b' }],
]);
export const Edit = createWpIcon('Edit', [
  ['path', { d: 'M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7', key: 'a' }],
  ['path', { d: 'M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5Z', key: 'b' }],
]);
export const Edit2 = createWpIcon('Edit2', [
  ['path', { d: 'M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z', key: 'a' }],
]);
export const Edit3 = createWpIcon('Edit3', [
  ['path', { d: 'M12 20h9', key: 'a' }],
  ['path', { d: 'M16.5 3.5a2.12 2.12 0 1 1 3 3L7 19l-4 1 1-4Z', key: 'b' }],
]);
export const Pen = createWpIcon('Pen', [
  ['path', { d: 'M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z', key: 'a' }],
]);
export const Pencil = createWpIcon('Pencil', [
  ['path', { d: 'M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z', key: 'a' }],
  ['path', { d: 'm15 5 4 4', key: 'b' }],
]);
export const PenTool = createWpIcon('PenTool', [
  ['path', { d: 'M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z', key: 'a' }],
  ['path', { d: 'm18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a.5.5 0 0 0-.4.858l11.938 11.938a.5.5 0 0 0 .858-.4z', key: 'b' }],
  ['path', { d: 'm2.3 2.3 7.286 7.286', key: 'c' }],
  ['circle', { cx: 11, cy: 11, r: 2, key: 'd' }],
]);
export const Trash2 = createWpIcon('Trash2', [
  ['path', { d: 'M3 6h18', key: 'a' }],
  ['path', { d: 'M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6', key: 'b' }],
  ['path', { d: 'M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2', key: 'c' }],
  ['line', { x1: 10, x2: 10, y1: 11, y2: 17, key: 'd' }],
  ['line', { x1: 14, x2: 14, y1: 11, y2: 17, key: 'e' }],
]);
export const Copy = createWpIcon('Copy', [
  ['rect', { width: 14, height: 14, x: 8, y: 8, rx: 2, ry: 2, key: 'a' }],
  ['path', { d: 'M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2', key: 'b' }],
]);
export const Save = createWpIcon('Save', [
  ['path', { d: 'M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z', key: 'a' }],
  ['path', { d: 'M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7', key: 'b' }],
  ['path', { d: 'M7 3v4a1 1 0 0 0 1 1h7', key: 'c' }],
]);
export const Download = createWpIcon('Download', [
  ['path', { d: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4', key: 'a' }],
  ['polyline', { points: '7 10 12 15 17 10', key: 'b' }],
  ['line', { x1: 12, x2: 12, y1: 15, y2: 3, key: 'c' }],
]);
export const Upload = createWpIcon('Upload', [
  ['path', { d: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4', key: 'a' }],
  ['polyline', { points: '17 8 12 3 7 8', key: 'b' }],
  ['line', { x1: 12, x2: 12, y1: 3, y2: 15, key: 'c' }],
]);
export const Send = createWpIcon('Send', [
  ['path', { d: 'M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z', key: 'a' }],
  ['path', { d: 'm21.854 2.147-10.94 10.939', key: 'b' }],
]);
export const Eraser = createWpIcon('Eraser', [
  ['path', { d: 'm7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21', key: 'a' }],
  ['path', { d: 'M22 21H7', key: 'b' }],
  ['path', { d: 'm5 11 9 9', key: 'c' }],
]);
export const Share2 = createWpIcon('Share2', [
  ['circle', { cx: 18, cy: 5, r: 3, key: 'a' }],
  ['circle', { cx: 6, cy: 12, r: 3, key: 'b' }],
  ['circle', { cx: 18, cy: 19, r: 3, key: 'c' }],
  ['line', { x1: 8.59, x2: 15.42, y1: 13.51, y2: 17.49, key: 'd' }],
  ['line', { x1: 15.41, x2: 8.59, y1: 6.51, y2: 10.49, key: 'e' }],
]);
